<template>
  <div class="online-contact-stage mt-6">
    <div class="section__lk-label"><span>Модули программы</span></div>
    <div class="section__lk-text">
      Нажмите на модуль, чтобы перейти к вебинару. После перехода модуль отмечается как пройденный.
    </div>
    <div class="section__lk-content-items online-contact-stage__items">
      <!-- Модуль со ссылкой — плашка-ссылка на вебинар, без ссылки — просто строка -->
      <component
          :is="module.external_link ? 'a' : 'div'"
          v-for="(module, index) in modules"
          :key="module.id"
          :id="'module-' + module.id"
          class="section__lk-content-item online-contact-stage__item"
          :class="{
            'online-contact-stage__item_odd': index % 2 === 0,
            'online-contact-stage__item_disabled': !module.external_link
          }"
          :href="module.external_link || null"
          :target="module.external_link ? '_blank' : null"
          :rel="module.external_link ? 'noopener' : null"
          @click="visit(module)">
        <div class="section__lk-content-item-left">
          <div class="icon video"></div>
          <div class="section__lk-content-item-separator"></div>
          <div class="section__lk-content-item-data">
            <div class="section__lk-content-item-data-content">
              <div>
                <div class="section__lk-content-item-data-title">
                  Вебинар
                </div>
                <div>
                  Модуль {{ module.index || index + 1 }}. {{ module.title }}
                  <img v-if="module.external_link" src="/pic/profile/arrow-up-right.svg" />
                </div>
                <div v-if="!module.external_link" class="online-contact-stage__note">
                  Ссылка на вебинар появится позже
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="section__lk-content-item-right section__lk-enroll">
          <div class="section__lk-enroll-icon">
            {{ isModulePassed(module) ? 'Пройден' : 'Не пройден' }}
          </div>
          <div class="section__lk-enroll-status">
            <div class="status" :class="isModulePassed(module) ? 'status_success' : 'status_init'"></div>
          </div>
        </div>
      </component>

      <div
          id="final-test"
          class="section__lk-content-item online-contact-stage__item online-contact-stage__item_disabled"
          :class="{'online-contact-stage__item_odd': modules.length % 2 === 0}">
        <div class="section__lk-content-item-left">
          <div class="icon test"></div>
          <div class="section__lk-content-item-separator"></div>
          <div class="section__lk-content-item-data">
            <div class="section__lk-content-item-data-content">
              <div>
                <div class="section__lk-content-item-data-title">
                  Итоговый тест
                </div>
                <div v-if="test && test.title">{{ test.title }}</div>
                <div v-if="testState === 'closed'" class="online-contact-stage__note">
                  Откроется после завершения всех модулей по решению организатора
                </div>
                <template v-else>
                  <div v-if="testState === 'open' && testResult && testResult.questionsCount" class="online-contact-stage__note">
                    {{ testResult.questionsCount }} {{ plural(testResult.questionsCount, ['вопрос', 'вопроса', 'вопросов']) }}<template v-if="testResult.duration">, {{ testResult.duration }} мин.</template><template v-if="testResult.max_attempts">, попыток: {{ testResult.max_attempts }}</template>
                  </div>
                  <div v-if="testState === 'started'" class="online-contact-stage__note">
                    Тест начат, но не завершён
                  </div>
                  <template v-if="isTestFinished">
                    <div class="online-contact-stage__note">{{ resultText }}</div>
                    <div v-if="testState === 'passed'" class="online-contact-stage__note">
                      Итоговый тест сдан
                    </div>
                    <div v-else-if="canRetake && testResult.attempts_left" class="online-contact-stage__note">
                      Осталось попыток: {{ testResult.attempts_left }}
                    </div>
                    <div v-else-if="!canRetake" class="online-contact-stage__note">
                      Попытки исчерпаны
                    </div>
                  </template>
                  <button type="button" class="btn btn-primary" @click="$emit('test-click')">
                    {{ testButtonText }}
                  </button>
                </template>
              </div>
            </div>
          </div>
        </div>
        <div class="section__lk-content-item-right section__lk-enroll">
          <div class="section__lk-enroll-icon">
            {{ testStatus.text }}
          </div>
          <div class="section__lk-enroll-status">
            <div class="status" :class="testStatus.className"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from "../../../../services/api.service";

const MODULE_SUCCESS = 'success'

export default {
  name: "OnlineContactStage",
  props: {
    modules: {
      type: Array,
      default() {
        return []
      }
    },
    participant: {
      type: Object,
      default: null
    },
    // Модули курса загружены (в том числе пустой список): до этого к якорю не прокручиваем
    loaded: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      // Модули, по которым слушатель перешёл в этой сессии
      visited: {},
      testResult: null,
      hashScrolled: false
    }
  },
  computed: {
    test() {
      return this.participant && this.participant.program && this.participant.program.test
          ? this.participant.program.test
          : null
    },
    isTestAccess() {
      return Boolean(this.participant && this.participant.is_test_access)
    },
    // Тест запрашиваем только при открытом доступе и включённом тесте, иначе API отдаст 403
    testKey() {
      return this.isTestAccess && this.test && this.test.id && this.test.is_active !== false ? this.test.id : null
    },
    testState() {
      if (!this.testKey) {
        return 'closed'
      }

      const result = this.testResult

      if (!result) {
        return 'open'
      }

      if (result.status === 'active') {
        return 'started'
      }

      if (result.user_results && result.user_results.finished_at) {
        if (result.is_passed === true) {
          return 'passed'
        }
        if (result.is_passed === false) {
          return 'failed'
        }
        // Порог задан, но зачёт попытки не посчитан: считаем по проценту, как бэкенд
        if (result.pass_percent != null && result.result_percent != null) {
          return Number(result.result_percent) >= Number(result.pass_percent) ? 'passed' : 'failed'
        }
        return 'finished'
      }

      return 'open'
    },
    isTestFinished() {
      return ['passed', 'failed', 'finished'].indexOf(this.testState) > -1
    },
    canRetake() {
      if (!this.testResult || this.testState === 'passed') {
        return false
      }
      if (typeof this.testResult.attempts_left === 'number') {
        return this.testResult.attempts_left > 0
      }
      // Без новых полей API: solved — попытки ещё есть, finished — израсходованы
      return this.testResult.status === 'solved'
    },
    resultText() {
      const result = this.testResult

      if (!result || !result.user_results) {
        return ''
      }

      let text = 'Результат: ' + (result.user_results.correct_count || 0)

      if (result.questionsCount) {
        text += ' из ' + result.questionsCount
      }

      if (result.result_percent !== null && result.result_percent !== undefined) {
        text += ' (' + String(Math.round(Number(result.result_percent) * 10) / 10).replace('.', ',') + '%)'
      }

      return text
    },
    testButtonText() {
      if (this.testState === 'started') {
        return 'Продолжить тест'
      }
      if (this.isTestFinished) {
        return this.canRetake ? 'Пересдать' : 'Посмотреть результат'
      }
      return 'Перейти к тесту'
    },
    testStatus() {
      switch (this.testState) {
        case 'passed':
          return {text: 'Зачёт', className: 'status_success'}
        case 'failed':
          return {text: 'Незачёт', className: 'status_failed'}
        case 'finished':
          return {text: 'Завершён', className: 'status_init'}
        case 'started':
          return {text: 'Начат', className: 'status_active'}
        case 'open':
          return {text: 'Доступен', className: 'status_active'}
        default:
          return {text: 'Закрыт', className: 'status_init'}
      }
    }
  },
  watch: {
    loaded: {
      handler() {
        this.scrollToHash()
      },
      immediate: true
    },
    testKey: {
      handler() {
        this.loadTestResult()
      },
      immediate: true
    }
  },
  methods: {
    // Склонение по числу: 1 вопрос, 2 вопроса, 5 вопросов (глобальный фильтр pluralize ошибается для 21–99)
    plural(n, forms) {
      const a = Math.abs(n) % 10
      const b = Math.abs(n) % 100
      if (a === 1 && b !== 11) {
        return forms[0]
      }
      if (a >= 2 && a <= 4 && (b < 10 || b >= 20)) {
        return forms[1]
      }
      return forms[2]
    },
    isModulePassed(module) {
      return Boolean(
          this.visited[module.id] ||
          (module.user_results && module.user_results.status_module === MODULE_SUCCESS)
      )
    },
    visit(module) {
      if (!module.external_link || this.isModulePassed(module)) {
        return
      }

      // Отметку ставим без ожидания ответа, переход по ссылке не блокируем.
      // Ошибки ApiService не бросает (интерцептор отдаёт response или undefined): снимаем отметку, если сервер её не принял
      this.$set(this.visited, module.id, true)
      ApiService.post('modules/' + module.id + '/visit', {}).then(response => {
        if (!response || response.status !== 200) {
          this.$delete(this.visited, module.id)
        }
      })
    },
    async loadTestResult() {
      this.testResult = null

      const testId = this.testKey

      if (!testId) {
        return
      }

      try {
        const response = await ApiService.get('tests/' + testId)

        if (response && response.status === 200 && this.testKey === testId) {
          this.testResult = response.data
        }
      } catch (error) {
        console.error('Ошибка при загрузке итогового теста:', error)
      }
    },
    // Глубокая ссылка из письма: /lk/online#module-{id} или /lk/online#final-test
    scrollToHash() {
      const hash = this.$route && this.$route.hash ? this.$route.hash.replace('#', '') : ''

      // И к модулю, и к итоговому тесту — только после загрузки модулей (в том числе пустого списка):
      // строки модулей над карточкой теста иначе сдвинут её вниз уже после прокрутки
      if (this.hashScrolled || !hash || !this.loaded) {
        return
      }

      let id = hash
      try {
        id = decodeURIComponent(hash)
      } catch (e) {
        // битый hash: ищем элемент как есть
      }

      this.$nextTick(() => {
        const element = document.getElementById(id)

        if (!element || this.hashScrolled) {
          return
        }

        this.hashScrolled = true
        element.scrollIntoView({behavior: 'smooth', block: 'center'})
      })
    }
  }
}
</script>

<style scoped>
.online-contact-stage .section__lk-content-items.online-contact-stage__items {
  margin-top: 2.4rem;
}

.online-contact-stage .section__lk-content-item.online-contact-stage__item {
  background-color: transparent;
  color: inherit;
  text-decoration: none;
}

.online-contact-stage .section__lk-content-item.online-contact-stage__item_odd {
  background-color: #F2F2F2;
}

.online-contact-stage .section__lk-content-item.online-contact-stage__item_disabled {
  cursor: default;
}

.online-contact-stage__note {
  color: #828282;
  font-size: 1.6rem;
  line-height: 2.4rem;
}
</style>
